import { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectAccessToken } from '../../../slices/staffSlice';
import { fetchRequests } from '../../../Requests/getRequests';
import { authStaff } from '../../../utils/constants';
import { show } from '../../../slices/toastSlice';
import { Dialog, Transition } from '@headlessui/react';
import { HugeiconsIcon } from '@hugeicons/react';
import { Cancel01Icon } from '@hugeicons/core-free-icons';
import { FormInput, Button } from '../../../components';

function Create({ isOpen, onClose, onCreated }) {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();

    const [name, setName] = useState('');
    const [code, setCode] = useState('');
    const [contactEmail, setContactEmail] = useState('');
    const [ipWhitelist, setIpWhitelist] = useState('');
    const [webhookUrl, setWebhookUrl] = useState('');
    const [processing, setProcessing] = useState(false);

    const resetForm = () => {
        setName('');
        setCode('');
        setContactEmail('');
        setIpWhitelist('');
        setWebhookUrl('');
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name || !code || !contactEmail) {
            dispatch(show({ type: 'error', state: true, message: 'Name, code, and contact email are required' }));
            return;
        }

        setProcessing(true);
        const headers = authStaff(accessToken);
        const res = await fetchRequests('/loans/staff/partner-apis', 'POST', headers, {}, {
            name,
            code,
            contactEmail,
            ipWhitelist,
            webhookUrl: webhookUrl || undefined
        });

        if (res?.err || res?.code === 401) {
            dispatch(show({ type: 'error', state: true, message: res?.err || res?.message || 'Failed to create partner' }));
        } else if (res?.apiKey) {
            dispatch(show({ type: 'success', state: true, message: 'Partner API created successfully' }));
            resetForm();
            onCreated(res.apiKey);
        }
        setProcessing(false);
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={handleClose}>
                <Transition.Child as={Fragment} enter="ease-out duration-200" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-150" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-black/30" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child as={Fragment} enter="ease-out duration-200" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-150" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                            <Dialog.Panel className="w-full max-w-lg bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden">
                                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 dark:border-gray-700">
                                    <Dialog.Title className="text-base font-semibold text-gray-900 dark:text-gray-50">
                                        Create Partner API
                                    </Dialog.Title>
                                    <button type="button" onClick={handleClose} className="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors">
                                        <HugeiconsIcon icon={Cancel01Icon} size={16} />
                                    </button>
                                </div>

                                <form onSubmit={handleSubmit} className="px-6 py-5 space-y-4">
                                    <div className="grid grid-cols-2 gap-4">
                                        <FormInput label="Partner Name" type="text" name="name" id="partner-name" value={name} setValue={setName} placeholder="Axis Pension Trust" />
                                        <FormInput label="Partner Code" type="text" name="code" id="partner-code" value={code} setValue={setCode} placeholder="AXIS" />
                                    </div>

                                    <FormInput label="Contact Email" type="email" name="contactEmail" id="contact-email" value={contactEmail} setValue={setContactEmail} placeholder="it@axispension.com" />

                                    <div>
                                        <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5">IP Whitelist</label>
                                        <input
                                            type="text"
                                            value={ipWhitelist}
                                            onChange={(e) => setIpWhitelist(e.target.value)}
                                            placeholder="192.168.1.1, 10.0.0.1 (comma separated, leave empty to allow all)"
                                            className="form-input text-sm"
                                        />
                                    </div>

                                    <FormInput label="Webhook URL (optional)" type="url" name="webhookUrl" id="webhook-url" value={webhookUrl} setValue={setWebhookUrl} placeholder="https://api.partner.com/callbacks" />

                                    <div className="flex items-center gap-3 pt-1">
                                        <Button
                                            btnText="Create Partner"
                                            btnClasses="inline-flex items-center px-4 py-2.5 text-sm font-medium text-white bg-[#1e3a6e] rounded-lg hover:bg-[#264d91] transition-colors"
                                            btnFunction={handleSubmit}
                                            btnType="submit"
                                            processing={processing}
                                        />
                                        <button type="button" onClick={handleClose} className="px-4 py-2.5 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors">
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}

export default Create;
